import { useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CompanySearch from "../../components/contract/CompanySearch";
import { createContract } from "../../api/contract/info";
import AttachmentBox from "../../components/common/papers/AttachmentBox";
import TableCell from "../../components/common/ui/TableCell";

const Info_new = () => {
  const [form, setForm] = useState({
    contract_type: "",
    contract_code: "",
    title: "",
    confirmer_company_name: "",
    amount: "",
    signed_date_actual: "",
    start_date_actual: "",
    end_date_actual: "",
    sign_date_expected: "",
    end_date_expected: "",
    memo: "",
    manualCompanyInput: false,
    construction_type: "본공사"
  });

  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { id: projectId } = useParams();
  // const construction_type = location.state?.construction_type || "본공사";
  //user
  const rawUser = localStorage.getItem("user");
  const user = rawUser ? JSON.parse(rawUser) : null;
  const currentUser = user?.name || ""

  const attachmentRef = useRef(null);

  const handleAmountChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    setForm({ ...form, amount: raw });
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("project", projectId);
      fd.append("construction_type", form.construction_type || "본공사");

      Object.keys(form).forEach((key) => {
        if (key !== "manualCompanyInput") fd.append(key, form[key]);
      });

      const res = await createContract(fd);
      const dnsId = typeof res.dns === "object" ? res.dns.id : res.dns;

      await attachmentRef.current?.save(dnsId);

      alert("계약이 등록되었습니다.");
      navigate(`../info`);
    } catch (err) {
      console.error(err);
      alert("등록 실패. 다시 시도해주세요.");
    }
  };

  return (
    <div className="p-6 ">

      {/* ---- 제목 ---- */}
      <div className="mb-6">
        <h2 className="text-title">계약 정보 등록</h2>
        <div className="h-px bg-gray-300 mt-2"></div>
      </div>

      {/* ---- 오른쪽 버튼 ---- */}
      <div className="flex justify-end mb-4">
        <button type="submit" form="contract-form" className="btn-save">
          등록
        </button>
      </div>

      <form id="contract-form" onSubmit={handleSubmit} className="space-y-6">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <tbody>

              {/* 계약 구분 / 계약 코드 */}
              <tr>
                <TableCell
                  label="계약 구분"
                  editing
                  input={
                    <select
                      name="contract_type"
                      value={form.contract_type}
                      onChange={handleChange}
                      className="input-base"
                    >
                      <option value="">선택</option>
                      <option value="지명경쟁입찰">지명경쟁입찰</option>
                      <option value="제한경쟁입찰">제한경쟁입찰</option>
                      <option value="일반경쟁입찰">일반경쟁입찰</option>
                      <option value="수의계약">수의계약</option>
                      <option value="협상계약">협상계약</option>
                      <option value="최저가낙찰">최저가낙찰</option>
                      <option value="종합평가낙찰">종합평가낙찰</option>
                      <option value="턴키">턴키</option>
                      <option value="기술제안입찰">기술제안입찰</option>
                      <option value="대안입찰">대안입찰</option>
                      <option value="단가계약">단가계약</option>
                      <option value="총액계약">총액계약</option>
                    </select>
                  }
                />

                <TableCell
                  label="계약 코드"
                  editing
                  input={
                    <input
                      type="text"
                      name="contract_code"
                      value={form.contract_code}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />
              </tr>

              {/* 계약명 / 금액 */}
              <tr>
                <TableCell
                  label="계약명"
                  editing
                  input={
                    <input
                      type="text"
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />

                <TableCell
                  label="계약 금액"
                  editing
                  input={
                    <input
                      type="text"
                      name="amount"
                      value={
                        form.amount
                          ? Number(form.amount).toLocaleString("ko-KR")
                          : ""
                      }
                      onChange={handleAmountChange}
                      className="input-base text-right"
                      placeholder="금액 입력"
                    />
                  }
                />
              </tr>

              {/* 주계약업체 / 최초계약일 */}
              <tr>
                <TableCell
                  label="주계약업체"
                  editing
                  input={
                    <div className="flex items-center gap-2 w-full">

                      {/* 직접입력 체크 */}
                      <label className="flex items-center gap-1 text-sm">
                        <input
                          type="checkbox"
                          checked={form.manualCompanyInput}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              manualCompanyInput: e.target.checked,
                              confirmer_company_name: "",
                            })
                          }
                        />
                        직접 입력
                      </label>

                      {form.manualCompanyInput ? (
                        <input
                          type="text"
                          name="confirmer_company_name"
                          value={form.confirmer_company_name}
                          onChange={handleChange}
                          className="input-base flex-1"
                          placeholder="업체명 입력"
                        />
                      ) : (
                        <div className="flex flex-1 gap-2">
                          <input
                            type="text"
                            value={form.confirmer_company_name}
                            readOnly
                            className="input-base flex-1 bg-gray-100"
                          />
                          <button
                            type="button"
                            onClick={() => setModalOpen(true)}
                            className="btn-basic px-3 py-1 whitespace-nowrap"
                          >
                            검색
                          </button>
                        </div>
                      )}
                      <CompanySearch
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                        onSelect={(company) =>
                          setForm({
                            ...form,
                            confirmer_company_name: company.name,
                            manualCompanyInput: false,
                          })
                        }
                      />
                    </div>
                  }
                />
                <TableCell
                  label="작성자(수정불가)"
                  editing={false}
                  value={
                    <div className="input-base bg-gray-100">
                      {currentUser || "작성자"}
                    </div>
                  }
                />                
              </tr>

              {/* 착수 / 종료 */}
              <tr>
              {/* 공종 */}
              <TableCell
                label="공종"
                editing            
                input={<div>
                  <input
                    type="text"
                    name="construction_type"
                    value={form.construction_type}
                    onChange={handleChange}
                    className="w-full border rounded-md px-3 py-2"
                    placeholder="공종을 입력하세요"
                  />
                </div>}
              />

                <TableCell
                  label="최초 계약일"
                  editing
                  input={
                    <input
                      type="date"
                      name="signed_date_actual"
                      value={form.signed_date_actual}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />                
              </tr>

              {/* 예정일 */}
              <tr>
                <TableCell
                  label="계약 착수일"
                  editing
                  input={
                    <input
                      type="date"
                      name="start_date_actual"
                      value={form.start_date_actual}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />                
                <TableCell
                  label="계약 종료일"
                  editing
                  input={
                    <input
                      type="date"
                      name="end_date_actual"
                      value={form.end_date_actual}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />                
              </tr>
              <tr>
                <TableCell
                  label="계약 예정일"
                  editing
                  input={
                    <input
                      type="date"
                      name="sign_date_expected"
                      value={form.sign_date_expected}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />                
                <TableCell
                  label="종료 예정일"
                  editing
                  input={
                    <input
                      type="date"
                      name="end_date_expected"
                      value={form.end_date_expected}
                      onChange={handleChange}
                      className="input-base"
                    />
                  }
                />
              </tr>

              {/* 특이사항 */}
              <tr>
                <TableCell
                  label="특이사항"
                  editing
                  colSpan={3}
                  input={
                    <textarea
                      name="memo"
                      value={form.memo}
                      onChange={handleChange}
                      className="input-base h-40 resize-none leading-relaxed"
                    />
                  }
                />
              </tr>

              {/* 첨부파일 */}
              <tr>
                <TableCell
                  label="첨부파일"
                  editing
                  colSpan={3}
                  input={<AttachmentBox ref={attachmentRef} />}
                />
              </tr>

            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
};

export default Info_new;
